export default __webpack_public_path__ + "static/media/signup.cc70fb70.svg";